import { useQuery } from '@tanstack/react-query';
import { getCancelledBacsReport } from './cancelledBacsApi';

export const createCancelledBacsHooks = () => {
  const useCancelledBacsReport = (options = {}) =>
    useQuery({
      queryKey: ['cancelledBacsReport', options],
      queryFn: () => getCancelledBacsReport(options),
      keepPreviousData: true,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, err) => {
        const status = err?.response?.status;
        if (status === 429) return false;
        return failureCount < 2;
      },
    });

  return {
    useCancelledBacsReport,
  };
};
